module.exports = __webpack_public_path__ + "img/livetag.d3581482.svg";